import OptInApi from '../api/OptInApi';
import FeedbackApi from '../api/FeedbackApi';
import OptInConstants from '../constants/OptInConstants';

export function openFeedbackForm(bundle) {
  return {
    type: OptInConstants.TOGGLE_OPT_IN_FEEDBACK_FORM,
    bundle,
    payload: {
      open: true
    }
  };
}

export function closeFeedbackForm(bundle) {
  return {
    type: OptInConstants.TOGGLE_OPT_IN_FEEDBACK_FORM,
    bundle,
    payload: {
      open: false
    }
  };
}

export function submitFeedback(bundle, feedback) {
  return {
    bundle,
    middlewareData: {
      authRequired: true
    },
    types: [
      OptInConstants.SUBMIT_OPT_IN_FEEDBACK_REQUEST,
      OptInConstants.SUBMIT_OPT_IN_FEEDBACK_SUCCESS,
      OptInConstants.SUBMIT_OPT_IN_FEEDBACK_FAILURE
    ],
    apiRequest: (state, apiClient) => FeedbackApi.submitFeedback(feedback, apiClient)
  };
}

export function optIn(bundle) {
  return {
    bundle,
    types: [
      OptInConstants.OPT_IN_REQUEST,
      OptInConstants.OPT_IN_SUCCESS,
      OptInConstants.OPT_IN_FAILURE
    ],
    apiRequest: (state, apiClient) => OptInApi.optIn(bundle, apiClient)
  };
}

export function optOut(bundle, currentLocation) {
  return {
    bundle,
    types: [
      OptInConstants.OPT_OUT_REQUEST,
      OptInConstants.OPT_OUT_SUCCESS,
      OptInConstants.OPT_OUT_FAILURE
    ],
    apiRequest: (state, apiClient) => OptInApi.optOut(bundle, currentLocation, apiClient)
  };
}

export function dismissOptIn(bundle) {
  return {
    type: OptInConstants.DISMISS_OPT_IN,
    payload: bundle
  };
}

export function closeFeedbackSuccessMessage(bundle) {
  return {
    type: OptInConstants.CLOSE_FEEDBACK_SUCCESS,
    payload: bundle
  };
}

export default {
  openFeedbackForm,
  closeFeedbackForm,
  submitFeedback,
  optIn,
  optOut,
  dismissOptIn,
  closeFeedbackSuccessMessage
};




// WEBPACK FOOTER //
// ./app/actions/OptInActions.js